import { SpacerLayoutItem } from '@/common/layout/SpacerLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Paper, Typography, useTheme } from '@mui/material';
import { darken } from '@mui/material/styles';
import { useState } from 'react';
import { DashboardCardProvider } from './DashboardCardContext';

export const DashboardCard = ({ title, icon, children, variant = 'standard', buttons, sx: sxOverride }) => {
  
  const [gridCount, setGridCount] = useState(0);

  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  let sx = {
    p: 0,
    minHeight: 0,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    border: '1px solid',
    borderColor: theme.palette.divider,
    backgroundColor: theme.palette.surface.main,
    overflow: 'hidden'
  };

  if (variant === 'bold') {
    const startColor = isDarkMode
      ? darken(theme.palette.primary.main, 0.15) // slightly transparent in dark
      : theme.palette.primary.main;

    const endColor = isDarkMode
      ? darken(theme.palette.primary.dark, 0.30) // slightly transparent in dark
      : theme.palette.primary.dark;

    sx = {
      ...sx,
      border: 'none',
      background: `linear-gradient(135deg, ${startColor} 0%, ${endColor} 100%)`,
      color: theme.palette.getContrastText(theme.palette.primary.dark),
    };
  }

  const finalSx = {
    ...sx,
    ...sxOverride
  };

  return (
    <SpacerLayoutItem>
      <DashboardCardProvider setGridCount={setGridCount}>
        <Paper elevation={variant === 'bold' ? 3 : 0} sx={finalSx}>
          <Box
            sx={{ display: 'flex', alignItems: 'baseline', gap: 1, flex: 0, minWidth: 0, justifyContent: 'space-between', p: 2 }}
          >
            {icon && <FontAwesomeIcon icon={icon} />}
            {title && (
              <Typography
                variant="h6"
                sx={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}>
                {title}
              </Typography>
            )}
            {/* Pushes buttons to the right */}
            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ display: 'flex', gap: 1 }}>
              {buttons}
            </Box>
          </Box>
          <Box
            sx={{
              flex: 1,
              minHeight: 0,
              overflow: 'auto',
              pt: 0,
              px: gridCount > 0 ? 0 : 2,
              pb: gridCount > 0 ? 0 : 2
            }}
          >
            {children}
          </Box>
        </Paper>
      </DashboardCardProvider>
    </SpacerLayoutItem>
  );
};
